import { PaymentTransactionDetailPage } from "@/features/payment-transaction/pages/PaymentTransactionDetailPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/payment-transaction/$id/detail")({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: ["it.monitoring.payment_transaction"],
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: PaymentTransactionDetailPage,
});
